<template>
  <v-tabs class="p-routed-tabs">
    <v-tab
      v-for="tab of tabs"
      :key="tab.route"
      :to="{ name: tab.route }"
    >
      {{ tab.title }}
    </v-tab>
  </v-tabs>
</template>


<script>
export default {
  props: {
    tabs: Array
  }
}
</script>
